// TODO remove this file when https://jira.esteeonline.com/browse/SDGLTMPL-2062 is done
export enum Brands {
    CLINIQUE = 'cl',
    GENIE = 'gn',
    JOMALONE = 'jm',
    GLAMGLOW = 'gg',
    ESTEELAUDER = 'el'
}
